export enum HelpCentreEndpoints {
  CATEGORIES = '/categories',
  CATEGORY = '/category',
  SUB_CATEGORY = '/sub-category',
  ARTICLE = '/article'
}
